var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-tmp"},_vm._l((20),function(i){return _c('div',{key:i,staticClass:"box-row"},_vm._l((20),function(j){return _c('div',{key:`${i}_${j}`,staticClass:"box-col"},[_c('span',{staticClass:"number"},[_vm._v(_vm._s((i * j) % 2))])])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }